import { render, staticRenderFns } from "./Diagram.vue?vue&type=template&id=d16b81a6&scoped=true"
import script from "./Diagram.vue?vue&type=script&lang=js"
export * from "./Diagram.vue?vue&type=script&lang=js"
import style0 from "./Diagram.vue?vue&type=style&index=0&id=d16b81a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16b81a6",
  null
  
)

export default component.exports